import React, { useEffect, useState } from "react";
import { SITE } from "../mock";

// Luxurious "open mouth" reveal overlay shown once per session
export const OpenMouthReveal = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      const seen = sessionStorage.getItem("zp_reveal_seen");
      if (!seen && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        setShow(true);
        const t = setTimeout(() => {
          setShow(false);
          sessionStorage.setItem("zp_reveal_seen", "1");
        }, 1100);
        return () => clearTimeout(t);
      }
    } catch (e) {
      // fail-safe: hide
      setShow(false);
    }
  }, []);

  if (!show) return null;

  return (
    <div className="reveal">
      <div className="reveal-top" />
      <div className="reveal-center">
        <img src={SITE.logoUrl} alt="Logo Zdravé packy" className="h-16 w-16 object-contain" />
      </div>
      <div className="reveal-bottom" />
    </div>
  );
};
